import Tags from "../models/Tags";
import request from "../shared/http";
import appConfig from "../shared/js/app-config";

class TagService {
  // constructor() {
  //   this.storageKey = "wappgrow_tags";
  //   this.tags = this.loadTags();
  // }

  // loadTags() {
  //   try {
  //     const stored = localStorage.getItem(this.storageKey);
  //     if (stored) {
  //       const tagsData = JSON.parse(stored);
  //       return tagsData.map((tagData) => TagModel.fromJSON(tagData));
  //     }
  //   } catch (error) {
  //     console.error("Error loading tags:", error);
  //   }
  //   return this.getDefaultTags();
  // }

  // saveTags() {
  //   try {
  //     const tagsData = this.tags.map((tag) => tag.toJSON());
  //     localStorage.setItem(this.storageKey, JSON.stringify(tagsData));
  //   } catch (error) {
  //     console.error("Error saving tags:", error);
  //   }
  // }

  // getDefaultTags() {
  //   return [
  //     new TagModel({
  //       id: "tag_1",
  //       name: "VIP",
  //       color: "#f44336",
  //       description: "Very Important Person",
  //       contactCount: 0,
  //     }),
  //     new TagModel({
  //       id: "tag_2",
  //       name: "Lead",
  //       color: "#ff9800",
  //       description: "Potential customer",
  //       contactCount: 0,
  //     }),
  //     new TagModel({
  //       id: "tag_3",
  //       name: "Customer",
  //       color: "#4caf50",
  //       description: "Active customer",
  //       contactCount: 0,
  //     }),
  //     new TagModel({
  //       id: "tag_4",
  //       name: "Prospect",
  //       color: "#2196f3",
  //       description: "Potential lead",
  //       contactCount: 0,
  //     }),
  //   ];
  // }

  // getAllTags() {
  //   return [...this.tags];
  // }

  // getTagById(id) {
  //   return this.tags.find((tag) => tag.id === id);
  // }

  // createTag(tagData) {
  //   const newTag = new TagModel(tagData);
  //   this.tags.push(newTag);
  //   this.saveTags();
  //   return newTag;
  // }

  // updateTag(id, updates) {
  //   const tagIndex = this.tags.findIndex((tag) => tag.id === id);
  //   if (tagIndex !== -1) {
  //     this.tags[tagIndex] = { ...this.tags[tagIndex], ...updates };
  //     this.tags[tagIndex].updatedAt = new Date().toISOString();
  //     this.saveTags();
  //     return this.tags[tagIndex];
  //   }
  //   return null;
  // }

  // deleteTag(id) {
  //   const tagIndex = this.tags.findIndex((tag) => tag.id === id);
  //   if (tagIndex !== -1) {
  //     const deletedTag = this.tags.splice(tagIndex, 1)[0];
  //     this.saveTags();
  //     return deletedTag;
  //   }
  //   return null;
  // }

  // updateContactCount(tagId, increment = true) {
  //   const tag = this.getTagById(tagId);
  //   if (tag) {
  //     tag.contactCount = Math.max(0, tag.contactCount + (increment ? 1 : -1));
  //     tag.updatedAt = new Date().toISOString();
  //     this.saveTags();
  //   }
  // }

  // getTagsByContactIds(contactIds) {
  //   // This would be used to get tags for specific contacts
  //   // For now, return all tags with their contact counts
  //   return this.tags;
  // }

  // searchTags(query) {
  //   const lowerQuery = query.toLowerCase();
  //   return this.tags.filter(
  //     (tag) =>
  //       tag.name.toLowerCase().includes(lowerQuery) ||
  //       tag.description.toLowerCase().includes(lowerQuery)
  //   );
  // }

  // getPopularTags(limit = 10) {
  //   return this.tags
  //     .sort((a, b) => b.contactCount - a.contactCount)
  //     .slice(0, limit);
  // }

  parseTags(item) {
    return {
      id: item.id,
      name: item.name,
      description: item.description,
      color: item.color,
      contactsCount: item.contacts_count || 0,
      createdAt: item.created_at,
    }
  }

  serializeTags(model) {
    return {
      id: model.getId() ?? null,
      name: model.getName(),
      description: model.getDescription(),
      color: model.getColor(),
    }
  }

  async createTags(tagData) {
    const url = `/tags/${appConfig.getServiceId()}`;
    const { data } = await request.post(url, this.serializeTags(tagData));
    return data;
  }
  async updateTags(tagData) {
    const url = `/tags/${appConfig.getServiceId()}`;
    const { data } = await request.put(url, this.serializeTags(tagData));
    return data;
  }

  async getAllTags(params={}) {
      const domain = window.location.origin;
    const url = `/tags/${appConfig.getServiceId()}`;
    const { data } = await request.get(url, {
      params: {
        offset: params.offset || 0,
        limit: params.limit || 1000,
        search: params.search,
        sortBy: params.sortBy || "created_at",
        sortOrder: params.sortOrder || "desc",
      }
    });
    return data.map((res) => new Tags(this.parseTags(res)));
  }

  async deleteTag(tagId) {
    const url = `/tags/${appConfig.getServiceId()}/${tagId}`;
    const { data } = await request.delete(url);
    return data;
  }
}

export default new TagService();
